export enum OrigemProtocoloEnum {
  SEI = 'SEI',
  INTERNO = 'INTERNO',
  PROCESSODIGITAL = 'PROCESSODIGITAL'
}
